import React from 'react';
import styles from './dwn-style.module.css';

const FitThankYou = () => {
  return (
    <div className={styles.fitRecruitmentContainer}>
      <h1>Thank you for your interest in the study.</h1>

      <section className={styles.aboutSection}>
        <h2 className={styles.sectionTitle}>Study Description</h2>
        <p className={styles.latinText}>
          This study checks the effectiveness of a family-based treatment for adolescent obesity.
          The study uses a mobile app and real, human personal health coaches to guide participants through the program.
        </p>
        <ul className={styles.latinText}>
          <li>12-week study</li>
          <li>Encourages health & wellness education, exercise, fitness tracking, & healthy nutrition</li>
          <li>Free access to evidence-based health & wellness content</li>
          <li>Free access to a real, human personal health coach</li>
        </ul>

        <h3 className={styles.sectionSubtitle}>Potential Benefits</h3>
        <p className={styles.latinText}>
          The study may improve your and your caregiver’s physical well-being, but that cannot be guaranteed.
        </p>

        <h3 className={styles.sectionSubtitle} style={{ color: 'darkgreen' }}>
          COMPENSATION AVAILABLE
        </h3>
        <p className={styles.latinText}>
          Each participant (adolescent <strong>AND</strong> caregiver) can earn up to <strong>$1400</strong>.
        </p>
      </section>
    </div>
  );
};

export default FitThankYou;

